module.exports = __webpack_public_path__ + "static/media/logo_hooli.c9d8e779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logos/logo_hooli.svg
// module id = 637
// module chunks = 0